export const formatDatePickerValue = (date: Date): string => {
  const yyyy = date.getFullYear();
  const mm = date.getMonth() > 8 ? `${date.getMonth() + 1}` : `0${date.getMonth() + 1}`;
  const dd = date.getDate() > 9 ? `${date.getDate()}` : `0${date.getDate()}`;
  return `${yyyy}-${mm}-${dd}T00:00:00.000Z`;
};
